
export const Styles = {
    // Rounding
    rounded: ' border-radius: 0.25rem;',
    roundedFull: ' border-radius: 9999px;',
    roundedSm: ' border-radius: 0.125rem;',
    roundedLg: ' border-radius: 0.5rem;',
    roundedMd: ' border-radius: 0.375rem;',
    roundedNone: ' border-radius: 0;',
    // Shadow
    shadow: ' box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);',
    shadow2xl: ' box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);',
    shadowInner: ' box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);',
    shadowLg: ' box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);',
    shadowMd: ' box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);',
    shadowNone: ' box-shadow: none;',
    shadowOutline: (color: string) => ` box-shadow: 0 0 0 .125rem ${color}`,
    shadowSm: ' box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);',
    shadowSolid: ' box-shadow: 0 0 0 2px currentColor;',
    shadowXl: ' box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);',
    shadowXs: ' box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);',
};
